import { formatDezimal } from '../../lib/lenses'
import type { FairBasis } from '../../services/qualyz'

/** Beschriftung der Basen -- dieselben Namen wie an den Linien der Kursgrafik. */
export const FAIR_BASEN: { key: FairBasis; label: string; lang: string }[] = [
  { key: 'kgv', label: 'Ø-KGV', lang: 'Durchschnitts-KGV' },
  { key: 'kuv', label: 'Ø-KUV', lang: 'Durchschnitts-KUV' },
  { key: 'dividende', label: 'Ø-Div.', lang: 'Durchschnitts-Dividendenrendite' },
]

/**
 * Ab hier gilt ein Potenzial als deutlich. Dieselbe Grenze wie in der Ansicht
 * "Unterbewertet" (fairwert_liste.UNTERBEWERTET_AB_POTENZIAL): Wenige Prozent
 * liegen im Rauschen eines Medians ueber elf Jahre.
 */
export const DEUTLICH_PCT = 10

/** "Kurs 20 % unter dem fairen Wert" -- dieselbe Lage, vom Kurs aus gesehen. */
export function lageText(potenzial: number): string {
  const abstand = (100 / (100 + potenzial) - 1) * 100
  return abstand < 0
    ? `Kurs ${formatDezimal(-abstand, 0)} % unter dem fairen Wert`
    : `Kurs ${formatDezimal(abstand, 0)} % über dem fairen Wert`
}

/**
 * Potenzial bis zum fairen Wert (Kim, 24.10.2026): "+25 %" heisst, der Kurs
 * muesste um 25 % steigen, um den fairen Wert zu erreichen. Deutlich darueber
 * gruen, deutlich darunter (Kurs ueber dem fairen Wert) in der Warnfarbe,
 * dazwischen neutral. Liegt das Ø-Vielfache ausserhalb der ueblichen Spanne,
 * wird der Wert gezeigt, aber blass und mit Grund (markieren statt verstecken).
 */
export default function FairPotenzial({
  potenzial,
  ausserhalb = false,
  titel,
}: {
  potenzial: number | null | undefined
  ausserhalb?: boolean
  titel?: string
}) {
  if (typeof potenzial !== 'number') {
    return (
      <span className="q-fair q-fair--leer" title={titel ?? 'Kein fairer Wert von heute'}>
        –
      </span>
    )
  }
  const art = ausserhalb
    ? 'aus'
    : potenzial >= DEUTLICH_PCT
      ? 'unter'
      : potenzial <= -DEUTLICH_PCT
        ? 'ueber'
        : 'nah'
  const hinweis =
    (titel ? `${titel}: ` : '') +
    `${potenzial >= 0 ? '+' : ''}${formatDezimal(potenzial, 0)} % bis zum fairen Wert · ${lageText(potenzial)}` +
    (ausserhalb ? ' · Ø-Vielfaches außerhalb der üblichen Spanne' : '')
  return (
    <span className={`q-fair q-fair--${art}`} title={hinweis}>
      {potenzial > 0 ? '+' : ''}
      {formatDezimal(potenzial, 0)} %
    </span>
  )
}
